import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { point, point_page, point_count } from '../../components/apipath';
import { switchHelper} from "../../modules/helpers";

function PointRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);

    // 讀取點數申請記錄
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${point_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setRequestList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    


    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${point_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    
    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const formatToMysqlDatetime = (dateInput) => {
        const date = new Date(dateInput);
        const pad = (n) => (n < 10 ? '0' + n : n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
               `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
    
        let finalValue;
    
        if (name === "e_material") {
            finalValue = parseInt(value, 10);
        } else if (type === "checkbox") {
            finalValue = switchHelper(checked);
        } else if (type === "number") {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prev => {
            const newData = {
                ...prev,
                [name]: finalValue
            };
    
            // 自動計算剩餘點數
            if (
                (name === 'total_points' || name === 'requested_points') &&
                newData.total_points !== undefined &&
                newData.requested_points !== undefined
            ) {
                newData.remaining_points_after = newData.total_points - newData.requested_points;
            }
    
            return newData;
        });
    };
    

    const saveChanges = async () => {
        try {
            const remaining = updatedData.total_points - updatedData.requested_points;
    
            const dataToSend = {
                ...updatedData,
                remaining_points_after: remaining,
                timestamp: formatToMysqlDatetime(new Date())
            };
    
            console.log("✅ 更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${point}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.id === updatedData.id ? response.data : req
                )
            );
            await fetchData();
            setEditingRequest(null);
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };
    
    

    // const formatDate = (dateString) => {
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始
    //     const day = String(date.getDate()).padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };
    
    // // 用法
    // const formattedDate = formatDate("2025-02-11T00:00:00.000Z");
    // console.log(formattedDate); // 2025-02-11

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        
        setUpdatedData(prevData => {
            const currentSubjects = prevData.core_subject ? prevData.core_subject.split(',') : [];
            let updatedSubjects;
            
            if (checked) {
                // 如果選中，新增該學科
                updatedSubjects = [...currentSubjects, value];
            } else {
                // 如果取消選中，移除該學科
                updatedSubjects = currentSubjects.filter(subject => subject !== value);
            }
    
            return {
                ...prevData,
                core_subject: updatedSubjects.join(',')  // 將陣列轉為逗號分隔的字串
            };
        });
    };
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    
    return (
        <>
            <div className="mt100 container">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <div className="mt-2">
                        <table className="table table-striped border table-responsive">
                            <thead>
                                <tr>
                                    <th>學生姓名</th>
                                    <th>學科</th>
                                    <th>電子講義</th>
                                    <th>申請點數</th>
                                    <th>剩餘點數</th>
                                    <th>總點數</th>
                                    <th>申請狀態</th>
                                    <th>申請日期</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                            {requestList.map((request) => (
                                <tr key={request.id}>
                                    {editingRequest && editingRequest.id === request.id ? (
                                        <>
                                            <td colSpan={10}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">學生姓名</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="student_name"
                                                                    value={updatedData.student_name}
                                                                    onChange={handleInputChange}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>   
                                                        <div className="col-md-6">
                                                            <div className="d-flex flex-wrap align-items-center">
                                                                <label className="form-label me-3">學科</label>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectFAR"
                                                                        value="FAR"
                                                                        checked={updatedData.core_subject?.includes("FAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectFAR">FAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectREG"
                                                                        value="REG"
                                                                        checked={updatedData.core_subject?.includes("REG")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectREG">REG</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectAUD"
                                                                        value="AUD"
                                                                        checked={updatedData.core_subject?.includes("AUD")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectAUD">AUD</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectBAR"
                                                                        value="BAR"
                                                                        checked={updatedData.core_subject?.includes("BAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">BAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectISC"
                                                                        value="ISC"
                                                                        checked={updatedData.core_subject?.includes("ISC")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">ISC</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectTCP"
                                                                        value="TCP"
                                                                        checked={updatedData.core_subject?.includes("TCP")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">TCP</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請點數</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    name="requested_points"
                                                                    value={updatedData.requested_points || ''}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">總點數</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    name="total_points"
                                                                    value={updatedData.total_points || ''}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">電子講義</span>
                                                                <select
                                                                className="form-select"
                                                                name="e_material"
                                                                value={String(updatedData.e_material)}
                                                                onChange={handleInputChange}
                                                                >
                                                                <option value="1">已領</option>
                                                                <option value="0">未領</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{request.student_name}</td>
                                            <td>{request.core_subject}</td>
                                            <td>{request.e_material === 1 ? "已領" : "未領"}</td>
                                            <td>{request.requested_points || ""}</td>
                                            <td>{request.remaining_points_after|| "未給予總點數"}</td>
                                            <td>{request.total_points || "未給予總點數"}</td>
                                            <td>{request.status}</td>
                                            <td>{formatDate(request.timestamp)}</td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                        </table>
                        {/* <div className="m-2 p-2">
                            {PageList(rowsCount, fetchData)}
                        </div> */}
                    </div>
                )}
            </div>
        </>
    );
}

export default PointRequest;
